import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#1A1889',
    secondary: '#F4F4F5',
    subText: '#828282',
    grayButton: '#C1C1C1',
    contaEscrow: '#175CD3',
    contaMovimento: '#6941C6',
    colorContaEscrow: '#828282',
    colorContaMovimento: '#3A3939',
    underlineText: '#0094FF',
    headerColor: '#F4F4F4',
    secondaryIB: '#2171BD',
    customColor_IB: '#10155D',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

const ambiente = localStorage.ambiente;
const urlCloudfront = `https://${window.env.VUE_APP_CLOUDFRONT_NAME}/parceiros/onboarding/${ambiente}/`

let aberturaDeConta = '/assets/imgs/abertura-de-conta.png'
let acompanheProcesso = '/assets/imgs/acompanhe-o-processo.png'
let voceNoControle = '/assets/imgs/voce-no-controle.png'
let movimentoImg = '/assets/imgs/movimento-img.svg'
let lockImage = `${urlCloudfront}lockImage` || '/assets/imgs/token.svg'
let headerColor = themes.light.headerColor
let chatAlert = `${urlCloudfront}chatAlert` || '/assets/imgs/chat-alert-img.svg'
let chat = `${urlCloudfront}chat` || '/assets/imgs/modal-confirmacao.svg'
let check = `${urlCloudfront}check` || '/assets/imgs/check.svg'
let mobileWhite = false
let background = `${urlCloudfront}background` || '/assets/imgs/background.svg'
let logo = `${urlCloudfront}logo` || '/assets/imgs/logo.svg';
let logoMobile = `${urlCloudfront}logoMobile` || '/assets/imgs/logo.svg'
let logoHome = `${urlCloudfront}logoHome` || '/assets/imgs/logo.svg';
let logoInverted = `${urlCloudfront}logoInverted` || '/assets/imgs/logo-inverted.svg'
let esqueceuSenha = '/assets/imgs/esqueceu-senha.svg'
let esqueceuSenhaSucesso = '/assets/imgs/esqueceu-senha-sucesso.svg'
let stepMobile1 = '/assets/imgs/mobile-1.svg'
let stepMobile2 = '/assets/imgs/mobile-2.svg'

try {
  if (ambiente) {
    require('@/assets/imgs/' + ambiente + '/background.svg')
    background = '/assets/imgs/' + ambiente + '/background.svg'
  }
} catch { }

try {
  var favicon = document.getElementById('custom-favicon')
  const caminhoFavIcon = `${urlCloudfront}favicon` || '/assets/imgs/logo.svg';
  favicon.setAttribute('href', caminhoFavIcon)
  if (ambiente) {
    require('@/assets/imgs/' + ambiente + '/logo.svg')
    const ambientesCustomizados = [];

    if (ambientesCustomizados.includes(window.env.VUE_APP_AMBIENTE)) {
      logo = '/assets/imgs/' + ambiente + '/logo.svg'
      logoInverted = '/assets/imgs/' + ambiente + '/logo-inverted.svg'
      logoHome = '/assets/imgs/' + ambiente + '/logo.svg'
      logoMobile = '/assets/imgs/' + ambiente + '/logo.svg'
      movimentoImg = '/assets/imgs/' + ambiente + '/movimento-img.svg'
      check = '/assets/imgs/' + ambiente + '/check.svg'
      lockImage = '/assets/imgs/' + ambiente + '/modais/lock-img.svg'
      chatAlert = '/assets/imgs/' + ambiente + '/chat-alert-img.svg'
      chat = '/assets/imgs/' + ambiente + '/chat-img.svg'
      aberturaDeConta = '/assets/imgs/' + ambiente + '/abertura-de-conta-color.png'
      acompanheProcesso = '/assets/imgs/' + ambiente + '/acompanhe-o-processo-color.png'
      voceNoControle = '/assets/imgs/' + ambiente + '/voce-no-controle-color.png'
      esqueceuSenha = '/assets/imgs/esqueceu-senha-color.svg'
      esqueceuSenhaSucesso = '/assets/imgs/esqueceu-senha-sucesso-color.svg'
      stepMobile1 = '/assets/imgs/mobile-1-color.svg'
      stepMobile2 = '/assets/imgs/mobile-2-color.svg'
      favicon.setAttribute('href', '/assets/imgs/' + ambiente + '/favicon.svg')
    }
  }
} catch { }

switch (window.env.VUE_APP_AMBIENTE) {
  case 'moka':
    themes = {
      light: {
        primary: '#E91E63',
        secondary: '#2A3477',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#2171BD',
        customColor_IB: '#10155D',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'nrb':
    themes = {
      light: {
        primary: '#0D1A34',
        secondary: '#2071D1',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#2171BD',
        customColor_IB: '#10155D',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'sifrabank':
    themes = {
      light: {
        primary: '#00244D',
        secondary: '#3A66FA',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#2171BD',
        customColor_IB: '#10155D',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'daniele':
    themes = {
      light: {
        primary: '#1E2B5B',
        secondary: '#269ADA',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#2171BD',
        customColor_IB: '#10155D',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'flow':
    themes = {
      light: {
        primary: '#0A2043',
        secondary: '#85754E',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#2171BD',
        customColor_IB: '#10155D',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'banicred':
    themes = {
      light: {
        primary: '#023D5A',
        secondary: '#72A5BF',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#2171BD',
        customColor_IB: '#10155D',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'multiplica':
    themes = {
      light: {
        primary: '#042041',
        secondary: '#0E4FC8',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#2171BD',
        customColor_IB: '#042041',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'lafontte':
    themes = {
      light: {
        primary: '#063C58',
        secondary: '#C19C67',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'wfcapital':
    themes = {
      light: {
        primary: '#262626',
        secondary: '#E0C389',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#2171BD',
        customColor_IB: '#262626',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'dmx':
    themes = {
      light: {
        primary: '#373435',
        secondary: '#96989A',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#2171BD',
        customColor_IB: '#373435',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'jpacred':
    themes = {
      light: {
        primary: '#38563D',
        secondary: '#313131',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#313131',
        customColor_IB: '#38563D',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'ajout':
    themes = {
      light: {
        primary: '#004aad',
        secondary: '#F4F4F5',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#313131',
        customColor_IB: '#38563D',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case '2xcapital':
    themes = {
      light: {
        primary: '#2D2D2D',
        secondary: '#AD965F',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#AD965F',
        customColor_IB: '#2D2D2D',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'nasapay':
    themes = {
      light: {
        primary: '#042F5A',
        secondary: '#5FBABC',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#5FBABC',
        customColor_IB: '#042F5A',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'conquest_brazil':
    themes = {
      light: {
        primary: '#345B91',
        secondary: '#4C4C4C',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#4C4C4C',
        customColor_IB: '#345B91',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'k2fidc':
    themes = {
      light: {
        primary: '#16212B',
        secondary: '#72839B',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#4C4C4C',
        customColor_IB: '#345B91',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'hotinvest':
    themes = {
      light: {
        primary: '#F74C2A',
        secondary: '#21437A',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#21437A',
        customColor_IB: '#F74C2A',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'leveldigital':
    themes = {
      light: {
        primary: '#070604',
        secondary: '#b9a356',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#21437A',
        customColor_IB: '#F74C2A',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'alphataurus':
    themes = {
      light: {
        primary: '#5AA660',
        secondary: '#173B2B',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#173B2B',
        customColor_IB: '#5AA660',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'grananet':
    themes = {
      light: {
        primary: '#03323E',
        secondary: '#456B73',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#456B73',
        customColor_IB: '#03323E',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'bxp':
    themes = {
      light: {
        primary: '#222CF3',
        secondary: '#00C9F3',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#00C9F3',
        customColor_IB: '#222CF3',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'nfnucleo':
    themes = {
      light: {
        primary: '#000000',
        secondary: '#1EB955',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#181413',
        customColor_IB: '#1EB955',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'gaveasul':
    themes = {
      light: {
        primary: '#145C95',
        secondary: '#D4E8F2',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#D4E8F2',
        customColor_IB: '#145C95',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'one7':
    themes = {
      light: {
        primary: '#1a284d',
        secondary: '#5ad4ff',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#5ad4ff',
        customColor_IB: '#1a284d',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'viainvest':
    themes = {
      light: {
        primary: '#2C2E65',
        secondary: '#E87722',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#E87722',
        customColor_IB: '#2C2E65',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'oxigenio':
    themes = {
      light: {
        primary: '#100221',
        secondary: '#F26719',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#D4E8F2',
        customColor_IB: '#145C95',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'infocapital':
    themes = {
      light: {
        primary: '#C17112',
        secondary: '#FDB128',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#D4E8F2',
        customColor_IB: '#145C95',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'whhold':
    themes = {
      light: {
        primary: '#393939',
        secondary: '#D1B168',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#D4E8F2',
        customColor_IB: '#145C95',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'gelmar':
    themes = {
      light: {
        primary: '#070045',
        secondary: '#F7941D',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#D4E8F2',
        customColor_IB: '#145C95',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'galopes':
    themes = {
      light: {
        primary: '#193C2B',
        secondary: '#DEAD60',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#D4E8F2',
        customColor_IB: '#145C95',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'axelx':
    themes = {
      light: {
        primary: '#212121',
        secondary: '#535B61',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#D4E8F2',
        customColor_IB: '#145C95',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'trevys':
    themes = {
      light: {
        primary: '#F7941D',
        secondary: '#FBB040',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#D4E8F2',
        customColor_IB: '#145C95',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'ybkdigital':
    themes = {
      light: {
        primary: '#95937E',
        secondary: '#004108',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#004108',
        customColor_IB: '#95937E',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'pagway':
    themes = {
      light: {
        primary: '#002364',
        secondary: '#0741AD',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#0741AD',
        customColor_IB: '#002364',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'boavistapay':
    themes = {
      light: {
        primary: '#1A2659',
        secondary: '#129EBA',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#129EBA',
        customColor_IB: '#1A2659',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'ultradigital':
    themes = {
      light: {
        primary: '#FF0000',
        secondary: '#000000',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#000000',
        customColor_IB: '#FF0000',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'ctni':
  case 'onboarding_ctni':
    themes = {
      light: {
        primary: '#750C31',
        secondary: '#AAAAAA',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#AAAAAA',
        customColor_IB: '#750C31',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'franchiinfinity':
    themes = {
      light: {
        primary: '#10069F',
        secondary: '#E0004D',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#AAAAAA',
        customColor_IB: '#750C31',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'orooficial':
    themes = {
      light: {
        primary: '#0E1B2E',
        secondary: '#5A90C8',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#494952',
        customColor_IB: '#3962AC',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'corredeira':
  case 'onboarding_corredeira':
    themes = {
      light: {
        primary: '#00113F',
        secondary: '#1718FF',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#1718FF',
        customColor_IB: '#00113F',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'laraescrow':
    themes = {
      light: {
        primary: '#000000',
        secondary: '#700DFF',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#700DFF',
        customColor_IB: '#000000',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'cabcredit':
    themes = {
      light: {
        primary: '#1E2327',
        secondary: '#B27F2B',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#700DFF',
        customColor_IB: '#000000',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'petrasolucoes':
  case 'onboarding_petrasolucoes':
    themes = {
      light: {
        primary: '#082C2D',
        secondary: '#54B3B8',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#700DFF',
        customColor_IB: '#000000',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'werthub':
    themes = {
      light: {
        primary: '#243428',
        secondary: '#F47942',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#F47942',
        customColor_IB: '#243428',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'conta_pilas':
  case 'onboarding_conta_pilas':
    themes = {
      light: {
        primary: '#075E3F',
        secondary: '#00A676',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#00A676',
        customColor_IB: '#075E3F',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'gii_digital':
    themes = {
      light: {
        primary: '#021F59',
        secondary: '#0460D9',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#00A676',
        customColor_IB: '#075E3F',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'indexah_capital':
    themes = {
      light: {
        primary: '#171437',
        secondary: '#160B70',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'qprof':
    themes = {
      light: {
        primary: '#004B48',
        secondary: '#00CD16',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'yaaleh':
    themes = {
      light: {
        primary: '#09305D',
        secondary: '#64B5F1',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'capitalcerto':
    themes = {
      light: {
        primary: '#020136',
        secondary: '#535DB9',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'incentiveplus':
    themes = {
      light: {
        primary: '#0A1C4D',
        secondary: '#0096DB',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'dorocapital':
    themes = {
      light: {
        primary: '#A39786',
        secondary: '#6E5324',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'banpar':
    themes = {
      light: {
        primary: '#FF7300',
        secondary: '#FFA000',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'fazprime':
    themes = {
      light: {
        primary: '#232C5A',
        secondary: '#354EBA',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'onboarding_oro':
    themes = {
      light: {
        primary: '#0E1B2E',
        secondary: '#5A90C8',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'nexepay':
    themes = {
      light: {
        primary: '#0055FF',
        secondary: '#2CBAE5',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'credvale':
    themes = {
      light: {
        primary: '#9A2027',
        secondary: '#B4B4B4',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'fatorialdigital':
    themes = {
      light: {
        primary: '#30435E',
        secondary: '#6E6E72',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'banminas':
    themes = {
      light: {
        primary: '#2E5546',
        secondary: '#9BC8B8',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'intra':
    themes = {
      light: {
        primary: '#003960',
        secondary: '#EAECED',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'cabcreditconta':
    themes = {
      light: {
        primary: '#F7DE7C',
        secondary: '#1E2327',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#17BF9F',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'bantdigital':
    themes = {
      light: {
        primary: '#000000',
        secondary: '#1202C3',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#1202C3',
        customColor_IB: '#000000',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'mosaicopay':
    themes = {
      light: {
        primary: '#3DA8A9',
        secondary: '#005359',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#005359',
        customColor_IB: '#3DA8A9',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'nitrodigital':
    themes = {
      light: {
        primary: '#0018FF',
        secondary: '#000000',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'prospera':
    themes = {
      light: {
        primary: '#1F4AB9',
        secondary: '#09296D',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#160B70',
        customColor_IB: '#171437',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'innercapital':
    themes = {
      light: {
        primary: '#002157 ',
        secondary: '#066C3B',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#066C3B',
        customColor_IB: '#002157 ',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'vrxservicos':
    themes = {
      light: {
        primary: '#1A2659 ',
        secondary: '#129EBA',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#129EBA',
        customColor_IB: '#1A2659 ',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'contacheia':
    themes = {
      light: {
        primary: '#212C55 ',
        secondary: '#4372B7',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#129EBA',
        customColor_IB: '#1A2659 ',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'abrafescdigital':
    themes = {
      light: {
        primary: '#001F5F ',
        secondary: '#B3BFFF',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#129EBA',
        customColor_IB: '#1A2659 ',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'agcontadigital':
    themes = {
      light: {
        primary: '#17375F ',
        secondary: '#E84185',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#129EBA',
        customColor_IB: '#1A2659 ',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'deltacredito':
    themes = {
      light: {
        primary: '#0A3250 ',
        secondary: '#0D71BC',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#129EBA',
        customColor_IB: '#1A2659 ',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'areab':
    themes = {
      light: {
        primary: '#004B85 ',
        secondary: '#FFFFFF',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#FFFFFF',
        customColor_IB: '#004B85 ',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
  case 'libexcapital':
    themes = {
      light: {
        primary: '#DAB874',
        secondary: '#000626',
        subText: '#828282',
        grayButton: '#C1C1C1',
        selectConta1: '#5A9ACF',
        selectConta2: '#2C3B66',
        underlineText: '#0094FF',
        secondaryIB: '#FFFFFF',
        customColor_IB: '#004B85 ',
        colorContaEscrow: '#1A1889',
        colorContaMovimento: '#9747FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    mobileWhite = true
    headerColor = '#F4F4F5'
    break
}

export default {
  dark: false,
  options: {
    customProperties: true,
    dense: false,
    formValidateTitle: ' ',
    toolbar: { color: headerColor },
    mobileWhite
  },
  background,
  chatAlert,
  chat,
  logo,
  logoHome,
  logoMobile,
  logoInverted,
  lockImage,
  movimentoImg,
  check,
  aberturaDeConta,
  acompanheProcesso,
  voceNoControle,
  esqueceuSenha,
  esqueceuSenhaSucesso,
  stepMobile1,
  stepMobile2,
  themes: themes
}
